import MergedViewAvailabilityOptionState from './schema/MergedViewAvailabilityOptionState';
import { createStore } from 'satcheljs';

/**
 * Creates store which reflects the current state of settings under Availability option
 */
export default createStore<MergedViewAvailabilityOptionState>('mergedViewAvailabilityOption', {
    mergedViewEnabledAccountInitial: null,
    mergedViewEnabledAccountCurrent: null,
    saveFailed: false,
});
